import { render, staticRenderFns } from "./LanguageMenu.vue?vue&type=template&id=9a6a7746&scoped=true"
import script from "./LanguageMenu.vue?vue&type=script&lang=js"
export * from "./LanguageMenu.vue?vue&type=script&lang=js"
import style0 from "./LanguageMenu.vue?vue&type=style&index=0&id=9a6a7746&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a6a7746",
  null
  
)

export default component.exports